<template>
    <div>
        <!-- <div class="card-tabs">
            <a class="lps" :class="tabsIndex==1?'on':''" @click="tabsIndex=1">卡券管理</a>
            <a class="lps" :class="tabsIndex==2?'on':''" @click="tabsIndex=2">卡券记录</a>
        </div> -->
        <div class="page-bg-white card-body">
            <div style="padding: 30px 0 5px 40px;">
                <el-form :inline="true" class="form-inline">
                    <el-form-item label="充值号码">
                        <el-input size="small" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            size="small"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-select size="small" placeholder="请选择状态" :value="state">
                            <el-option label="全部" value="1"></el-option>
                            <el-option label="充值失败" value="2"></el-option>
                            <el-option label="充值失败" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page-bg-white card-body" style="margin-top: 20px">
            <div style="padding: 30px 0">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="date" label="充值时间"></el-table-column>
                    <el-table-column prop="name" label="操作员"></el-table-column>
                    <el-table-column prop="name" label="充值账号"></el-table-column>
                    <el-table-column prop="name" label="充值金额"></el-table-column>
                    <el-table-column prop="name" label="冲正时间"></el-table-column>
                    <el-table-column prop="name" label="状态"></el-table-column>
                    <el-table-column prop="address" label="地址" width="250"></el-table-column>
                </el-table>
            </div>
            <div style="text-align: right; padding: 40px 0">
                <el-pagination background layout="prev, pager, next" :total="1000"> </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            tabsIndex: 1,
            state: '',
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }]
        }
    }
}
</script>
